"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderUtils = void 0;
const __1 = require("..");
const getName = (order, fallback = "") => {
    var _a, _b;
    if ((order === null || order === void 0 ? void 0 : order.id) === null)
        return "Stock";
    let name = ((_a = order === null || order === void 0 ? void 0 : order.client) === null || _a === void 0 ? void 0 : _a.companyName) || ((_b = order === null || order === void 0 ? void 0 : order.client) === null || _b === void 0 ? void 0 : _b.name) || fallback;
    if (name)
        return name;
    return `${(order === null || order === void 0 ? void 0 : order.status) === __1.EOrderStatus.offer ? "Offer" : "Order"} ${order === null || order === void 0 ? void 0 : order.id}`;
};
const getSubtotal = (order) => {
    var _a, _b;
    let subtotal = 0;
    (_a = order === null || order === void 0 ? void 0 : order.orderProducts) === null || _a === void 0 ? void 0 : _a.forEach(({ price = 0, amount = 0 }) => (subtotal += amount * price));
    (_b = order === null || order === void 0 ? void 0 : order.extras) === null || _b === void 0 ? void 0 : _b.forEach(({ price }) => {
        subtotal += price || 0;
    });
    return Math.floor(subtotal * 100) / 100;
};
const getDiscount = (order) => {
    return __1.numberUtils.twoDecimals((order === null || order === void 0 ? void 0 : order.discount) || 0);
};
const getDiscountPercentageBasedOnDiscount = (order) => {
    if (order.discountPercentage)
        return order.discountPercentage;
    if (!order.discount)
        return 0;
    const subtotal = getSubtotal(order);
    const discount = getDiscount(order);
    return (discount / subtotal) * 100;
};
const getPackingCost = (order) => {
    return __1.numberUtils.twoDecimals((order === null || order === void 0 ? void 0 : order.packingCost) || 0);
};
const getTransportCost = (order) => {
    return __1.numberUtils.twoDecimals((order === null || order === void 0 ? void 0 : order.transportCost) || 0);
};
const getImportDuties = (order) => {
    return __1.numberUtils.twoDecimals((order === null || order === void 0 ? void 0 : order.importDuties) || 0);
};
const getTotalExclVAT = (order) => {
    const subtotal = getSubtotal(order);
    let totalExclVAT = subtotal -
        ((order === null || order === void 0 ? void 0 : order.discount) || 0) +
        ((order === null || order === void 0 ? void 0 : order.packingCost) || 0) +
        ((order === null || order === void 0 ? void 0 : order.transportCost) || 0) +
        ((order === null || order === void 0 ? void 0 : order.importDuties) || 0);
    totalExclVAT = Math.round(totalExclVAT * 100) / 100;
    totalExclVAT = Math.max(0, totalExclVAT);
    return totalExclVAT;
};
const getVAT = (order) => {
    const VAT = getTotalExclVAT(order) * (((order === null || order === void 0 ? void 0 : order.vatPercentage) || 0) / 100);
    return Math.round(VAT * 100) / 100;
};
const getTotalInclVAT = (order) => {
    const totalInclVAT = getTotalExclVAT(order) + getVAT(order);
    return Math.round(totalInclVAT * 100) / 100;
};
const getCurrencySymbol = (order) => {
    if ((order === null || order === void 0 ? void 0 : order.currency) === "usdollar")
        return "$";
    if ((order === null || order === void 0 ? void 0 : order.currency) === "euro")
        return "€";
    return "";
};
const isOffer = (order) => {
    return (order === null || order === void 0 ? void 0 : order.status) === __1.EOrderStatus.offer;
};
const isPending = (order) => {
    return (order === null || order === void 0 ? void 0 : order.status) === __1.EOrderStatus.pending;
};
const isRunning = (order) => {
    return (order === null || order === void 0 ? void 0 : order.status) === __1.EOrderStatus.order;
};
exports.orderUtils = {
    getName,
    getCurrencySymbol,
    getSubtotal,
    getDiscount,
    getDiscountPercentageBasedOnDiscount,
    getImportDuties,
    getPackingCost,
    getTransportCost,
    getTotalExclVAT,
    getVAT,
    getTotalInclVAT,
    isOffer,
    isPending,
    isRunning,
};
//# sourceMappingURL=orderUtils.js.map